var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rwd-cards d-lg-none"},[(!_vm.items || _vm.items.length === 0)?_c('div',{staticClass:"rwd-cards__empty"},[_vm._v(" "+_vm._s(_vm.emptyText)+" ")]):_vm._e(),_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"rwd-card"},[_vm._t("card",null,{"item":item,"index":index})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }